export const CURL = 'cURL';
export const CURLFORMDATA = 'cURL (Form Data)';
export const CURLWIN = 'cURL (Win)';
export const CURLPOSIX = 'cURL (POSIX)';
export const SWAGGER = 'Swagger';
export const SWAGGERFORM = 'Swagger (Form Data)';
